import { render, staticRenderFns } from "./PublicationTable.vue?vue&type=template&id=27d8c9dc&"
import script from "./PublicationTable.vue?vue&type=script&lang=js&"
export * from "./PublicationTable.vue?vue&type=script&lang=js&"
import style0 from "./PublicationTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports